let snackbarTimeout = null;

function isKeyboardOpen() {
    if (!window.visualViewport) return false;

    return window.visualViewport.height < window.innerHeight * 0.75;
}

function showSnackbar(message, duration = 5000, variant = 'error', analytics_event_data = {}) {
    const snackbar = document.getElementById('snackbar');
    const snackbarMessage = document.getElementById('snackbar-message');
    const snackbarIconError = document.getElementById('snackbar-icon-error');
    const snackbarIconSuccess = document.getElementById('snackbar-icon-success');
    const snackbarIconCopy = document.getElementById('snackbar-icon-copy');

    if (!snackbar || !snackbarMessage) return;

    variant = normalizeSnackbarVariant(variant);
    const isSuccess = variant === 'success';
    const isCopy = variant === 'copy';

    snackbarMessage.textContent = message;
    snackbarIconError?.classList.toggle('hidden', isSuccess || isCopy);
    snackbarIconSuccess?.classList.toggle('hidden', !isSuccess);
    snackbarIconCopy?.classList.toggle('hidden', !isCopy);

    if (isKeyboardOpen()) {
        snackbar.style.bottom = '-80px';
    } else {
        snackbar.style.bottom = '';
    }

    snackbar.classList.remove('translate-y-[calc(100%+12px)]', 'opacity-0', 'pointer-events-none');

    snackbar.classList.add('translate-y-0', 'opacity-100', 'pointer-events-auto');

    if (snackbarTimeout) {
        clearTimeout(snackbarTimeout);
    }

    snackbarTimeout = setTimeout(hideSnackbar, duration);

    if (window.sendAnalytics && Object.keys(analytics_event_data).length !== 0) {
        window.sendAnalytics(analytics_event_data);
    }
}

function normalizeSnackbarVariant(variant) {
    if (variant === true) return 'success';
    if (variant === false) return 'error';

    return variant;
}

function hideSnackbar() {
    const snackbar = document.getElementById('snackbar');

    if (!snackbar) return;

    snackbar.classList.remove('translate-y-0', 'opacity-100', 'pointer-events-auto');

    snackbar.classList.add('translate-y-[calc(100%+12px)]', 'opacity-0', 'pointer-events-none');
}

document.addEventListener('showSnackbar', event => {
    const data = event.detail;
    if (data?.message) {
        const variant = data.status ?? data.variant ?? data.is_success ?? data.isSuccess ?? 'error';
        const analytics_event_data = data.analytics_event ?? {};
        showSnackbar(data.message, data.duration || 5000, variant, analytics_event_data);
    }
});

document.addEventListener('htmx:afterRequest', event => {
    const xhr = event.detail.xhr;
    if (!xhr) return;

    const triggerHeader = xhr.getResponseHeader('HX-Trigger');

    if (triggerHeader === 'showSnackbar') {
        try {
            const responseText = xhr.responseText;

            if (!responseText) return;

            const data = JSON.parse(responseText);

            if (data.message) {
                const variant = data.status ?? data.variant ?? data.is_success ?? data.isSuccess ?? 'error';
                const analytics_event_data = data.analytics_event ?? {};
                showSnackbar(data.message, data.duration || 5000, variant, analytics_event_data);
            }
        } catch (e) {
            showSnackbar('Произошла ошибка', 5000);
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {
    if (!window.visualViewport) return;

    const snackbar = document.getElementById('snackbar');
    if (!snackbar) return;

    const baseHeight = window.visualViewport.height;

    const handleKeyboard = () => {
        const viewportHeight = window.visualViewport.height;
        const keyboardOpen = viewportHeight < baseHeight - 100;

        if (keyboardOpen) {
            snackbar.classList.add('hidden');
        } else {
            snackbar.classList.remove('hidden');
        }
    };

    window.visualViewport.addEventListener('resize', handleKeyboard);
});

window.showSnackbar = showSnackbar;
window.hideSnackbar = hideSnackbar;
